import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Tag, Shirt, Activity, Sparkles, BookOpen } from "lucide-react";

const ICONS = { hoodie: Shirt, bands: Activity, grooming: Sparkles, journal: BookOpen };

export default function Merch() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/merch").then((r) => setItems(r.data));
  }, []);

  const discount = user && typeof user === "object" && user.subscription
    ? user.subscription.plan_id === "don" ? 40
      : user.subscription.plan_id === "elevate" ? 25 : 10
    : 0;

  const claim = (id) => {
    if (!user || typeof user !== "object") {
      toast.error("Sign in to unlock member pricing");
      return;
    }
    if (!user.subscription) {
      toast.error("Activate a membership to claim your perk");
      return;
    }
    const code = `GRC${discount}-${id.toUpperCase()}`;
    navigator.clipboard?.writeText(code).catch(() => {});
    toast.success(`Perk code ${code} copied to clipboard`);
  };

  return (
    <section id="merch" data-testid="merch-vault-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="eyebrow">Members-Only Vault</div>
            <h2 className="font-display text-4xl sm:text-5xl uppercase mt-2">
              Perks & <span className="gold-text">Merch</span>
            </h2>
            <p className="text-[var(--text-secondary)] mt-3 max-w-xl">
              Streetwear, mobility gear, grooming rituals. Members save {discount || "up to 40"}%.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((m, i) => {
            const Icon = ICONS[m.image] || Tag;
            return (
              <div
                key={m.id}
                data-testid={`merch-item-${m.image}`}
                className="gr-card p-6 flex flex-col gr-rise"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="aspect-square rounded-xl bg-[var(--bg-elevated)] border border-[var(--border-subtle)] grid place-items-center text-[var(--gold)]">
                  <Icon size={64} strokeWidth={1} />
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="eyebrow">{m.tag}</span>
                  <span className="text-xs font-mono text-[var(--text-secondary)]">${m.price}</span>
                </div>
                <h3 className="font-display text-lg uppercase mt-2 leading-tight">{m.name}</h3>
                {discount > 0 && (
                  <div className="text-xs text-[var(--gold)] mt-2">You save {discount}% today</div>
                )}
                <button
                  data-testid={`claim-perk-btn-${m.image}`}
                  onClick={() => claim(m.id)}
                  className="mt-4 gr-btn-ghost py-2 rounded-full text-xs"
                >
                  Claim Perk Code
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
